import {Configuration} from './Configuration';
import {ConnectBasicEntityExt} from '../../framework/message/ConnectBasicEntityExt';
import {EngineExt} from '../../engineparam/message/EngineExt';
import {Flow} from './Flow';
import {TranslatedEmb} from '../../../../allkey/locale/message/TranslatedEmb';

export class ProcessExt extends ConnectBasicEntityExt {
description: TranslatedEmb;
engines: {[key: string]: EngineExt};
flows: {[key: string]: Flow};
label: TranslatedEmb;
params: Configuration;
visionCode: string;
}

